export default "__VITE_ASSET__CsZe2aMT__"